import MapGroupedLocationsUpdater from './MapGroupedLocationsUpdater';

export default class SearchMapHelper {
    public static getPrecisionFromZoom(zoom: number): number {
        return Math.min(Math.max(zoom, 1), MapGroupedLocationsUpdater.maximumZoomLevel);
    }
}
